/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, directive } from 'lit/directive.js';
/*
  @experimental
  Only use within storybook demos
*/
export class SpreadProps extends Directive {
    render() {
        return '';
    }
    update(part, params) {
        Object.entries(params[0])
            .filter(([k, v]) => v !== part.element[k])
            .forEach(([k, v]) => (part.element[k] = v));
        return this.render();
    }
}
export const spreadProps = directive(SpreadProps);
